import {FieldName} from "@/components/extension/settings/types";

export const extensionFieldsetGeneric: FieldName[] = [
    "displayName",
    "mobileNumber",
    "homeNumber",
    "notificationEmail",
    "voicemailToEmailEnabled",
    "pin",
    "alternateCallerNumberId",
    "alias",
    "locationId",
    "featureRestrictions",
    "hotNumber",
    "secretaryNumberId",
    "groupMembershipGroupIds",
    "nationalCac",
    "internationalCac",
];

export const extensionFieldsetCall: FieldName[] = [
    "callWaiting",
    "previewFeaturesEnabled",
    "cliro",
    "connectedNumberPresentationRestrictionOverride",
    "callLimit",
    "maliciousCallTrace",
    "directInwardDialing",
    "directOutwardDialing",
    "privateRoutingType",
    "nonPaymentBlockingType",
    "callOriginationDenied",
    "callTerminationDenied",
    "outgoingCallBarringOperator",
];

export const extensionFieldsetUser: FieldName[] = [
    "mobileNumber",
    "homeNumber",
    "notificationEmail",
    "voicemailToEmailEnabled",
    "pin",
    "hotNumber",
    "callWaiting",
    "outgoingCallBarringUser",
];
